import { useEffect, useMemo } from 'react';
import { BrowserAudioFlow } from '../../../services/audio-flow';

export function useAudioFlow(assessmentId: string) {
  const collector = useMemo(
    () => new BrowserAudioFlow(assessmentId),
    [assessmentId],
  );
  useEffect(() => {
    collector.resume();
    const hide = () => collector.dispose();
    const show = () => collector.resume();
    window.addEventListener('pagehide', hide);
    window.addEventListener('pageshow', show);
    return () => {
      window.removeEventListener('pagehide', hide);
      window.removeEventListener('pageshow', show);
      collector.dispose();
    };
  }, [collector]);
  return collector;
}
